import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaMenuItemModule } from '../area-menu-item/area-menu-item.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { UserInfoModule } from '../userInfo/user-info.module';
import { SubToolbarComponent } from './sub-toolbar.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavToolbarModule } from '@caslink/common-client/ng-app/nav-toolbar/nav-toolbar.module';

@NgModule({
    declarations: [
        SubToolbarComponent
    ],
    entryComponents: [
        SubToolbarComponent
    ],
    exports: [
        SubToolbarComponent
    ],
    imports: [
        CommonModule,
        AreaMenuItemModule,
        UserInfoModule,
        MatToolbarModule,
        NavToolbarModule
    ],
})
export class SubToolbarModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            SubToolbarComponent
        ]);
    }
}
